export default "__VITE_ASSET__Cf4eT87D__"